var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgTitleCollapsed3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 480,
    zoomAndPan: "magnify",
    viewBox: "0 0 360 72",
    height: 96,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "b094984eb2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "539aa18b77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 359.953125 0 L 359.953125 72 L 0 72 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e0f0ad9f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48 0 L 311.953125 0 C 338.460938 0 359.953125 21.492188 359.953125 48 L 359.953125 49.046875 C 359.953125 75.558594 338.460938 97.046875 311.953125 97.046875 L 48 97.046875 C 21.492188 97.046875 0 75.558594 0 49.046875 L 0 48 C 0 21.492188 21.492188 0 48 0 Z M 48 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.00448608,
    gradientTransform: "matrix(0.379094, 0, 0, 0.379094, -0.00170065, 0.000002)",
    y1: 128,
    x2: 949.508931,
    gradientUnits: "userSpaceOnUse",
    y2: 128,
    id: "4483c5b71f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 59.199524%, 69.799805%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.192261%, 59.300232%, 69.659424%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.578308%, 59.501648%, 69.380188%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.964355%, 59.70459%, 69.100952%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.348877%, 59.907532%, 68.821716%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.734924%, 60.108948%, 68.544006%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.120972%, 60.31189%, 68.264771%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.507019%, 60.514832%, 67.985535%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.893066%, 60.716248%, 67.706299%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.279114%, 60.919189%, 67.427063%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.665161%, 61.120605%, 67.149353%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.051208%, 61.323547%, 66.870117%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.437256%, 61.526489%, 66.590881%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.823303%, 61.727905%, 66.311646%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.209351%, 61.930847%, 66.033936%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.595398%, 62.132263%, 65.7547%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.981445%, 62.335205%, 65.475464%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.365967%, 62.538147%, 65.196228%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.752014%, 62.739563%, 64.916992%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.138062%, 62.942505%, 64.639282%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.524109%, 63.143921%, 64.360046%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.910156%, 63.346863%, 64.080811%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.296204%, 63.549805%, 63.801575%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.682251%, 63.751221%, 63.523865%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.068298%, 63.954163%, 63.244629%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.454346%, 64.155579%, 62.965393%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.840393%, 64.358521%, 62.686157%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.22644%, 64.561462%, 62.406921%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.612488%, 64.762878%, 62.129211%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.998535%, 64.96582%, 61.849976%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.384583%, 65.168762%, 61.57074%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.769104%, 65.370178%, 61.291504%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.155151%, 65.57312%, 61.012268%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.541199%, 65.774536%, 60.734558%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.927246%, 65.977478%, 60.455322%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.313293%, 66.18042%, 60.176086%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.699341%, 66.381836%, 59.896851%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.085388%, 66.584778%, 59.619141%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.471436%, 66.786194%, 59.339905%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.857483%, 66.989136%, 59.060669%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.24353%, 67.192078%, 58.781433%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.629578%, 67.393494%, 58.502197%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.015625%, 67.596436%, 58.224487%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.401672%, 67.797852%, 57.945251%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.78772%, 68.000793%, 57.666016%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.172241%, 68.203735%, 57.38678%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.558289%, 68.405151%, 57.107544%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.944336%, 68.608093%, 56.829834%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.330383%, 68.809509%, 56.550598%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.716431%, 69.012451%, 56.271362%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.102478%, 69.215393%, 55.992126%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.488525%, 69.416809%, 55.714417%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.874573%, 69.619751%, 55.435181%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.26062%, 69.821167%, 55.155945%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.646667%, 70.024109%, 54.876709%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.032715%, 70.227051%, 54.597473%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.418762%, 70.428467%, 54.319763%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.80481%, 70.631409%, 54.040527%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.189331%, 70.834351%, 53.761292%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.575378%, 71.035767%, 53.482056%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.961426%, 71.238708%, 53.204346%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.347473%, 71.440125%, 52.92511%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.733521%, 71.643066%, 52.645874%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.119568%, 71.846008%, 52.366638%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.505615%, 72.047424%, 52.087402%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.891663%, 72.250366%, 51.809692%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.27771%, 72.451782%, 51.530457%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.663757%, 72.654724%, 51.251221%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.049805%, 72.857666%, 50.971985%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.435852%, 73.059082%, 50.692749%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.821899%, 73.262024%, 50.415039%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.207947%, 73.46344%, 50.135803%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.592468%, 73.666382%, 49.856567%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.978516%, 73.869324%, 49.577332%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.364563%, 74.07074%, 49.299622%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.75061%, 74.273682%, 49.020386%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.136658%, 74.475098%, 48.74115%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.522705%, 74.67804%, 48.461914%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.908752%, 74.880981%, 48.182678%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.2948%, 75.082397%, 47.904968%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.680847%, 75.285339%, 47.625732%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.066895%, 75.486755%, 47.346497%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.452942%, 75.689697%, 47.067261%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.838989%, 75.892639%, 46.789551%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.225037%, 76.094055%, 46.510315%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.611084%, 76.296997%, 46.231079%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.995605%, 76.499939%, 45.951843%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.381653%, 76.701355%, 45.672607%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.7677%, 76.904297%, 45.394897%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.153748%, 77.105713%, 45.115662%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.539795%, 77.308655%, 44.836426%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.925842%, 77.511597%, 44.55719%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.31189%, 77.713013%, 44.277954%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.697937%, 77.915955%, 44.000244%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.083984%, 78.117371%, 43.721008%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.470032%, 78.320312%, 43.441772%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.856079%, 78.523254%, 43.162537%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.242126%, 78.72467%, 42.884827%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.628174%, 78.927612%, 42.605591%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.012695%, 79.129028%, 42.326355%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.398743%, 79.33197%, 42.047119%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.78479%, 79.534912%, 41.767883%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.170837%, 79.736328%, 41.490173%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.556885%, 79.93927%, 41.210938%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.942932%, 80.140686%, 40.931702%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.328979%, 80.343628%, 40.652466%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.715027%, 80.54657%, 40.374756%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.101074%, 80.747986%, 40.09552%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.487122%, 80.950928%, 39.816284%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.873169%, 81.152344%, 39.537048%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.259216%, 81.355286%, 39.257812%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.645264%, 81.558228%, 38.980103%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.031311%, 81.759644%, 38.700867%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.415833%, 81.962585%, 38.421631%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.80188%, 82.165527%, 38.142395%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.187927%, 82.366943%, 37.863159%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.573975%, 82.569885%, 37.585449%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.960022%, 82.771301%, 37.306213%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.346069%, 82.974243%, 37.026978%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.732117%, 83.177185%, 36.747742%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.118164%, 83.378601%, 36.470032%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.504211%, 83.581543%, 36.190796%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.890259%, 83.782959%, 35.91156%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.276306%, 83.985901%, 35.632324%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.662354%, 84.188843%, 35.353088%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.048401%, 84.390259%, 35.075378%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.434448%, 84.593201%, 34.796143%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.81897%, 84.794617%, 34.516907%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.205017%, 84.997559%, 34.237671%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "92a139d088"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b094984eb2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -36,
    width: 432,
    fill: "#000000",
    y: -7.2,
    height: 86.4,
    fillOpacity: 0.79
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "e08f76ccec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.6875 0.164062 L 30 0.164062 L 30 33 L 0.6875 33 Z M 0.6875 0.164062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 2564842967
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 0.164062 L 55 0.164062 L 55 33 L 25 33 Z M 25 0.164062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d0eb7f2d0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50 0.164062 L 80 0.164062 L 80 33 L 50 33 Z M 50 0.164062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5d00b5df89"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 81,
    y: 0,
    height: 34
  })), /*#__PURE__*/React.createElement("mask", {
    id: "55374fbd0d"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b094984eb2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -36,
    width: 432,
    fill: "#000000",
    y: -7.2,
    height: 86.4,
    fillOpacity: 0.55
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "3e76a6fc95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.222656 0 L 31 0 L 31 33 L 1.222656 33 Z M 1.222656 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab5e0ef4ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 0 L 56 0 L 56 33 L 26 33 Z M 26 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "760111bd39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 51 0 L 81.472656 0 L 81.472656 33 L 51 33 Z M 51 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dbbf2ef34b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 82,
    y: 0,
    height: 34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3dbfc09d36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 48.523438 L 359.933594 48.523438 L 359.933594 72 L 0 72 Z M 0 48.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.00390625,
    gradientTransform: "matrix(0.0917029, 0, 0, 0.0917029, -0.000358214, 48.524061)",
    y1: 128,
    x2: 3925.003974,
    gradientUnits: "userSpaceOnUse",
    y2: 128,
    id: "cc384861d8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 59.199524%, 69.799805%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.192261%, 59.300232%, 69.659424%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.576782%, 59.501648%, 69.380188%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.96283%, 59.70459%, 69.100952%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.348877%, 59.907532%, 68.823242%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.734924%, 60.108948%, 68.544006%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.120972%, 60.31189%, 68.264771%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.507019%, 60.513306%, 67.985535%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.893066%, 60.716248%, 67.706299%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.279114%, 60.919189%, 67.428589%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.665161%, 61.120605%, 67.149353%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.051208%, 61.323547%, 66.870117%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.437256%, 61.524963%, 66.590881%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.823303%, 61.727905%, 66.313171%)",
    offset: 0.101563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.207825%, 61.930847%, 66.033936%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.593872%, 62.132263%, 65.7547%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.979919%, 62.335205%, 65.475464%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.365967%, 62.536621%, 65.196228%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.752014%, 62.739563%, 64.918518%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.138062%, 62.942505%, 64.639282%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.524109%, 63.143921%, 64.360046%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.910156%, 63.346863%, 64.080811%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.296204%, 63.548279%, 63.803101%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.682251%, 63.751221%, 63.523865%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.068298%, 63.954163%, 63.244629%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.45282%, 64.155579%, 62.965393%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.838867%, 64.358521%, 62.686157%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.224915%, 64.559937%, 62.408447%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.610962%, 64.762878%, 62.129211%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.997009%, 64.96582%, 61.849976%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.383057%, 65.167236%, 61.57074%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.769104%, 65.370178%, 61.29303%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.155151%, 65.571594%, 61.013794%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.541199%, 65.774536%, 60.734558%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.927246%, 65.977478%, 60.455322%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.313293%, 66.178894%, 60.177612%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.699341%, 66.381836%, 59.898376%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.083862%, 66.583252%, 59.619141%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.46991%, 66.786194%, 59.339905%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.855957%, 66.989136%, 59.060669%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.242004%, 67.190552%, 58.782959%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.628052%, 67.393494%, 58.503723%)",
    offset: 0.320313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.014099%, 67.59491%, 58.224487%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.400146%, 67.797852%, 57.945251%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.786194%, 68.000793%, 57.667542%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.172241%, 68.202209%, 57.388306%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.558289%, 68.405151%, 57.10907%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.944336%, 68.606567%, 56.829834%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.330383%, 68.809509%, 56.550598%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.714905%, 69.012451%, 56.272888%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.100952%, 69.213867%, 55.993652%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.487%, 69.416809%, 55.714417%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.873047%, 69.618225%, 55.435181%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.259094%, 69.821167%, 55.157471%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.645142%, 70.024109%, 54.878235%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.031189%, 70.225525%, 54.598999%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.417236%, 70.428467%, 54.319763%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.803284%, 70.629883%, 54.040527%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.189331%, 70.832825%, 53.762817%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.575378%, 71.035767%, 53.483582%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.9599%, 71.237183%, 53.204346%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.345947%, 71.440125%, 52.92511%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.731995%, 71.641541%, 52.6474%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.118042%, 71.844482%, 52.368164%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.504089%, 72.047424%, 52.088928%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.890137%, 72.24884%, 51.809692%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.276184%, 72.451782%, 51.531982%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.662231%, 72.653198%, 51.252747%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.048279%, 72.85614%, 50.973511%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.434326%, 73.059082%, 50.694275%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.820374%, 73.260498%, 50.415039%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.206421%, 73.46344%, 50.137329%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.590942%, 73.664856%, 49.858093%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.97699%, 73.867798%, 49.578857%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.363037%, 74.07074%, 49.299622%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.749084%, 74.272156%, 49.021912%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.135132%, 74.475098%, 48.742676%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.521179%, 74.676514%, 48.46344%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.907227%, 74.879456%, 48.184204%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.293274%, 75.082397%, 47.904968%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.679321%, 75.283813%, 47.627258%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.065369%, 75.486755%, 47.348022%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.451416%, 75.688171%, 47.068787%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.837463%, 75.891113%, 46.789551%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.221985%, 76.094055%, 46.511841%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.608032%, 76.295471%, 46.232605%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.99408%, 76.498413%, 45.953369%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.380127%, 76.701355%, 45.674133%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.766174%, 76.902771%, 45.394897%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.152222%, 77.105713%, 45.117188%)",
    offset: 0.695313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.538269%, 77.307129%, 44.837952%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.924316%, 77.510071%, 44.558716%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.310364%, 77.713013%, 44.27948%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.696411%, 77.914429%, 44.00177%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.082458%, 78.117371%, 43.722534%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.46698%, 78.318787%, 43.443298%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.853027%, 78.521729%, 43.164062%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.239075%, 78.72467%, 42.886353%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.625122%, 78.926086%, 42.607117%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.011169%, 79.129028%, 42.327881%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.397217%, 79.330444%, 42.048645%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.783264%, 79.533386%, 41.769409%)",
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.169312%, 79.736328%, 41.491699%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.555359%, 79.937744%, 41.212463%)",
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.941406%, 80.140686%, 40.933228%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.327454%, 80.342102%, 40.653992%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.713501%, 80.545044%, 40.376282%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.098022%, 80.747986%, 40.097046%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.48407%, 80.949402%, 39.81781%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.870117%, 81.152344%, 39.538574%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.256165%, 81.35376%, 39.259338%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.642212%, 81.556702%, 38.981628%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.028259%, 81.759644%, 38.702393%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.414307%, 81.96106%, 38.423157%)",
    offset: 0.882813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.800354%, 82.164001%, 38.143921%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.186401%, 82.365417%, 37.866211%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.572449%, 82.568359%, 37.586975%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.958496%, 82.771301%, 37.307739%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.344543%, 82.972717%, 37.028503%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.729065%, 83.175659%, 36.749268%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.115112%, 83.377075%, 36.471558%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.50116%, 83.580017%, 36.192322%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.887207%, 83.782959%, 35.913086%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.273254%, 83.984375%, 35.63385%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.659302%, 84.187317%, 35.35614%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.045349%, 84.388733%, 35.076904%)",
    offset: 0.976563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.431396%, 84.591675%, 34.797668%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.817444%, 84.794617%, 34.518433%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.203491%, 84.996033%, 34.240723%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#539aa18b77)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e0f0ad9f20)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#4483c5b71f)",
    d: "M 0 0 L 0 72 L 359.953125 72 L 359.953125 0 Z M 0 0 ",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#92a139d088)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 88, -0.000000000000001479)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5d00b5df89)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e08f76ccec)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 29.734375 16.558594 L 23.390625 10.179688 L 23.355469 10.214844 L 13.375 0.199219 L 0.6875 0.273438 L 17.011719 16.558594 L 0.6875 32.847656 L 13.375 32.917969 L 23.355469 22.90625 L 23.390625 22.941406 Z M 29.734375 16.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2564842967)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 54.824219 16.558594 L 48.480469 10.179688 L 48.445312 10.214844 L 38.464844 0.199219 L 25.8125 0.273438 L 42.101562 16.558594 L 25.8125 32.847656 L 38.464844 32.917969 L 48.445312 22.90625 L 48.480469 22.941406 Z M 54.824219 16.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d0eb7f2d0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 79.953125 16.558594 L 73.574219 10.179688 L 73.574219 10.214844 L 63.59375 0.199219 L 50.90625 0.273438 L 67.191406 16.558594 L 50.90625 32.847656 L 63.59375 32.917969 L 73.574219 22.90625 L 73.574219 22.941406 L 79.953125 16.558594 L 79.917969 16.558594 Z M 79.953125 16.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#55374fbd0d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 208, -0.000000000000001479)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dbbf2ef34b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3e76a6fc95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 30.5625 16.558594 L 24.15625 10.113281 L 24.117188 10.152344 L 14.039062 0.0351562 L 1.222656 0.105469 L 17.710938 16.558594 L 1.222656 33.011719 L 14.039062 33.082031 L 24.117188 22.964844 L 24.15625 23.003906 Z M 30.5625 16.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab5e0ef4ae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 55.90625 16.558594 L 49.5 10.113281 L 49.460938 10.152344 L 39.382812 0.0351562 L 26.601562 0.105469 L 43.054688 16.558594 L 26.601562 33.011719 L 39.382812 33.082031 L 49.460938 22.964844 L 49.5 23.003906 Z M 55.90625 16.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#760111bd39)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00bf63",
    d: "M 81.285156 16.558594 L 74.839844 10.113281 L 74.839844 10.152344 L 64.761719 0.0351562 L 51.945312 0.105469 L 68.398438 16.558594 L 51.945312 33.011719 L 64.761719 33.082031 L 74.839844 22.964844 L 74.839844 23.003906 L 81.285156 16.558594 L 81.25 16.558594 Z M 81.285156 16.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3dbfc09d36)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cc384861d8)",
    d: "M 0 48.523438 L 0 72 L 359.933594 72 L 359.933594 48.523438 Z M 0 48.523438 ",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTitleCollapsed3);
export default __webpack_public_path__ + "static/media/bg-title-collapsed_3.4b9635955a7a06ea32b544b8ecb306d2.svg";
export { ForwardRef as ReactComponent };